
import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

export const usePlatformStats = () => {
  return useQuery({
    queryKey: ['platform-stats'],
    queryFn: async () => {
      const { data, error } = await supabase.rpc('get_platform_stats');
      if (error) throw error;
      return data[0];
    },
    refetchInterval: 30000, // Refresh every 30 seconds
  });
};

export const useUserGrowthAnalytics = (daysBack: number = 30) => {
  return useQuery({
    queryKey: ['user-growth-analytics', daysBack],
    queryFn: async () => {
      const { data, error } = await supabase.rpc('get_user_growth_analytics', {
        days_back: daysBack
      });
      if (error) throw error;
      return data;
    },
  });
};

export const useContentAnalytics = (daysBack: number = 30) => {
  return useQuery({
    queryKey: ['content-analytics', daysBack],
    queryFn: async () => {
      const { data, error } = await supabase.rpc('get_content_analytics', {
        days_back: daysBack
      });
      if (error) throw error;
      return data;
    },
  });
};

export const useTopContributors = (limit: number = 10) => {
  return useQuery({
    queryKey: ['top-contributors', limit],
    queryFn: async () => {
      const { data, error } = await supabase.rpc('get_top_contributors', {
        limit_count: limit
      });
      if (error) throw error;
      return data;
    },
  });
};

export const usePopularNodes = (limit: number = 10) => {
  return useQuery({
    queryKey: ['popular-nodes', limit],
    queryFn: async () => {
      const { data, error } = await supabase.rpc('get_popular_nodes', {
        limit_count: limit
      });
      if (error) throw error;
      return data;
    },
  });
};

export const useAdminLogs = (limit: number = 50) => {
  return useQuery({
    queryKey: ['admin-logs', limit],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('admin_logs')
        .select(`
          *,
          admin:profiles!admin_id(username, full_name)
        `)
        .order('created_at', { ascending: false })
        .limit(limit);
      
      if (error) throw error;
      return data;
    },
  });
};

export const useSystemNotifications = () => {
  return useQuery({
    queryKey: ['system-notifications'],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('system_notifications')
        .select(`
          *,
          creator:profiles!created_by(username, full_name)
        `)
        .order('created_at', { ascending: false });
      
      if (error) throw error;
      return data;
    },
  });
};
